import { render, staticRenderFns } from "./consultArticle.vue?vue&type=template&id=79a1a05b&scoped=true"
import script from "./consultArticle.vue?vue&type=script&lang=js"
export * from "./consultArticle.vue?vue&type=script&lang=js"
import style0 from "./consultArticle.vue?vue&type=style&index=0&id=79a1a05b&prod&lang=css"
import style1 from "./consultArticle.vue?vue&type=style&index=1&id=79a1a05b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a1a05b",
  null
  
)

export default component.exports